module.exports = __webpack_public_path__ + "img/9cbee35.png";